import React, { useState } from 'react';
import './Land.css';
import Pop from '../assets/land.png';
import PdfViewer4 from '../About/PdfViewer4';
import Loader from '../Loader/Loader'; // import the Loader component

const Population = () => {
  const [showPdfViewer4, setShowPdfViewer4] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer4(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <img src={Pop} alt='asals' className="image" />
      <div className="description">
        <h2>Land area by county (Sq. Km)</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer4 ? (
          <PdfViewer4 onClose={() => setShowPdfViewer4(false)} />
        ) : (
          <>
            <p>The land area gives a thorough picture of land resource size, and distribution. This data can
be used to guide... </p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
    </div>
  );
};

export default Population;
